import { Container, Grid, styled } from '@mui/material'

export const Wrapper = styled(Container)`
  margin: ${props => props.margin};
`

export const GridWrapper = styled(Grid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.align};

  &.MuiGrid-item {
    margin: ${props => props.margin};
  }
`
export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]}

  &:hover{
    color: ${props => props.theme.palette.blue[35]}
  }

  &:visited{
    color: ${props => props.theme.palette.blue[50]}
  }
`
